import React from 'react';
import PropTypes from 'prop-types';

import { Button, Tooltip } from '@metarouter-private/mr-mui';
import { useUserContext } from '@ion/user/context/UserContext';

import { useOrgOverrideModalContext } from '../OrgOverrideModalContext';

export default function ActionCell({ row }) {
  const { isOrgOverride } = useUserContext();
  const { openModal } = useOrgOverrideModalContext();
  const disabledForOrg = row.metadata.orgOverride === 'disabled';
  let tooltip = '';

  if (isOrgOverride) {
    tooltip = 'Org override is currently enabled';
  } else if (disabledForOrg) {
    tooltip = `Org override is disabled for the ${row.display_name} organization`;
  }

  return (
    <Tooltip title={tooltip}>
      <span>
        <Button
          disabled={isOrgOverride || disabledForOrg}
          onClick={() => {
            openModal(row);
          }}
        >
          Enable
        </Button>
      </span>
    </Tooltip>
  );
}

ActionCell.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    display_name: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      orgOverride: PropTypes.string,
    }).isRequired,
  }).isRequired,
};
